<template >
    <div class="form-group table-responsive col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4">
        <table id="annoucementList" cellspacing="0" width="100%" class="table table-bordered table-striped table-head-fixed" >
            <thead>
                <tr>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Sl.No.</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Configuration For</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Window Status</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of created</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:30%'>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(std, index) in configuration" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td v-if="std.config_id === 'Admission'">
                        <b><i class="fas fa-user-graduate"></i> Online Admission For Class PP</b>
                    </td>
                    <!-- <td v-else-if="std.config_id === 'private'">
                        <b><i class="fas fa-user-graduate"></i> Class XI for Private & Rigzhung</b>
                    </td>
                    <td v-else-if="std.config_id === 'outside_cluster'">
                        <b><i class="fas fa-user-graduate"></i> Class XI outside Cluster</b>
                    </td>
                    <td v-else-if="std.config_id === 'within_cluster'">
                        <b><i class="fas fa-user-graduate"></i> Class XI within Cluster</b>
                    </td> -->
                    <td v-else>
                        <b><i class="fas fa-poll"></i> Academic Result</b>
                    </td>
                    <td :style="{ color: std.status == '1' ? 'green' : 'red' }">
                        <i :class="std.status == '1' ? 'fas fa-check-circle' : 'fas fa-times-circle'" style="margin-right: 5px;"></i>
                        {{ std.status == '1' ? 'Open' : 'Closed' }}
                    </td>
                    <td>{{ std.created_at }}</td>
                    <td>
                        <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="loadeditpage(std)">
                        <span class="fas fa-edit" style="margin-right: 5px;"></span> Edit
                        </a>
                    </td>
                    </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            configuration:[],
            dt:'',
            class_form: new form({
                dzongkhag:'',
                org:'',
                class:'',
                stream:'',
                section:'',
            }),
        }
    },
    methods: {
        loadeditpage(data){
            this.$router.push({name:"edit_configuration",params:{data:data}});
        },
        ConfiurationListDetails(){
            this.configuration =[];
            let uri="";
                uri='configurationList';
                axios.get(uri)
                .then(response => {
                    let data = response.data;
                    this.configuration = data;
                });
        },
        /**
         * method to remove fields
         */
        Delete(id){
            Swal.fire({
                text: "Are you sure you want to delete from list?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('announcementDelete/'+id)
                    .then(() => {
                        this.configuration();
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },

    },
    
   async mounted(){
        this.ConfiurationListDetails();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
        })
        // this.dt =  $("#annoucementList").DataTable();
        this.dt = $("#annoucementList").DataTable({
            "order": [[ 0, "asc" ]],
            "lengthChange": false,
            "searching": false,
        }) 
    },

    watch: {
        configuration() {
            this.dt.destroy();
            this.$nextTick(() => {
                this.dt =  $("#annoucementList").DataTable()
            });
        }
    },
}
</script>
